// v1.0.2 §3 "Fund account": a hand-off to the brokerage's own funding page. Agence never moves
// money. Starting a hand-off records which account and when, so that on returning to the app
// FundingHandoffWatcher can look for the deposit. A hand-off is forgotten after a day.

// Alpaca's documented login page. Question 6 to Alpaca asks for a stable link to Funds & Wallet;
// replace this if they give one.
export const FUNDING_URL = 'https://app.alpaca.markets/account/login';

const KEY = 'fundingHandoff';
export const HANDOFF_TTL_MS = 24 * 60 * 60 * 1000;

export function startHandoff(accountId) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ accountId, startedAt: new Date().toISOString() }));
  } catch { /* storage unavailable: the deposit just isn't announced */ }
}

export function clearHandoff() {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}

// The current hand-off, or null. One older than a day is cleared.
export function readHandoff() {
  let parsed = null;
  try { parsed = JSON.parse(localStorage.getItem(KEY)); } catch { parsed = null; }
  if (!parsed?.accountId || !parsed?.startedAt) return null;
  if (Date.now() - new Date(parsed.startedAt).getTime() > HANDOFF_TTL_MS) {
    clearHandoff();
    return null;
  }
  return parsed;
}
